import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Typo from 'constants/typography'
import Icon, { ICONS, ICON_SIZE } from 'components/common/icon'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { formatSoldLabel } from 'lib/utils/product-sales'

const ProductItemPriceSection = ({
  t,
  cy,
  onClick,
  productId,
  productUrl,
  displayPrice,
  discountBadge,
  priceFormatted,
  isShowFlashSaleIcon,
  discountedPriceFormatted,
  is_best_price_guaranteed,
  salesCount,
  language,
}) => {
  const soldLabel = formatSoldLabel(salesCount, t, language)
  const isShowDiscountedPrice =
    discountedPriceFormatted && discountedPriceFormatted !== priceFormatted

  const renderPriceContent = () => {
    if (!isShowDiscountedPrice) {
      return (
        <span
          className={clsx(
            'product_price__wrapper',
            'without-discount',
            Typo.price2,
          )}
          data-cy={`product_item_price_${productId}`}
        >
          {priceFormatted}
        </span>
      )
    }

    return (
      <div className="product_price__wrapper with-discount">
        <span className={clsx('discounted__price', Typo.price2)}>
          {discountedPriceFormatted}
        </span>
        <span
          className={clsx(Typo.price2, 'with-discount-original-price')}
          data-cy={`product_item_price_${productId}__discount`}
        >
          {priceFormatted}
        </span>
        {!!discountBadge && (
          <span
            className="reduction-label"
            data-cy={cy ? `${cy}__reduction` : undefined}
          >
            <span className={Typo.price2}>{`-${discountBadge}`}</span>
            {isShowFlashSaleIcon && (
              <Icon src={ICONS.flashSale} size={ICON_SIZE.extraSmall} />
            )}
          </span>
        )}
      </div>
    )
  }

  return (
    <div
      className={clsx('product_price_wishlist__container', {
        'has-sold-count': displayPrice && soldLabel,
      })}
    >
      {displayPrice && (
        <a href={productUrl} className="product_price__link" onClick={onClick}>
          {renderPriceContent()}
          {is_best_price_guaranteed && (
            <span
              className={clsx(
                'product_price_wishlist__container__is_best_price_guaranteed',
                Typo.overline,
              )}
            >
              {hasLocizeTranslation(
                t,
                'BEST_PRICE_GUARANTEED',
                'Best Price Guaranteed',
              )}
            </span>
          )}
        </a>
      )}
      {displayPrice && soldLabel && (
        <span
          className="product-item__sold-count"
          data-cy={`product_item_sold_${productId}`}
        >
          {soldLabel}
        </span>
      )}
    </div>
  )
}

ProductItemPriceSection.defaultProps = {
  cy: '',
  discountedPriceFormatted: '',
  displayPrice: false,
  onClick: () => null,
  priceFormatted: '',
  productId: 0,
  productUrl: '',
  isShowFlashSaleIcon: false,
  discountBadge: '',
  is_best_price_guaranteed: false,
  salesCount: null,
  language: 'en',
}

ProductItemPriceSection.propTypes = {
  t: PropTypes.func.isRequired,
  cy: PropTypes.string,
  onClick: PropTypes.func,
  productId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  productUrl: PropTypes.string,
  displayPrice: PropTypes.bool,
  discountBadge: PropTypes.string,
  priceFormatted: PropTypes.string,
  isShowFlashSaleIcon: PropTypes.bool,
  discountedPriceFormatted: PropTypes.node,
  is_best_price_guaranteed: PropTypes.bool,
  salesCount: PropTypes.number,
  language: PropTypes.string,
}

export default withI18next()(ProductItemPriceSection)
